module.exports = __webpack_public_path__ + "img/undraw_my_feed_inj0.61273ea2.svg";